$(document).ready(function () {
  var mobileView = $(window).width() <= 649;
  var desktopView = $(window).width() >= 645;
  var regularPrice = $(".custom-varinat-input-name:checked").attr("cuspricecount");
  if (regularPrice) {
    $(".addtocart-product-price").text(regularPrice);
  }
  var capPrice = $(".custom-varinat-input-name:checked").attr("compare_prc");
  if (capPrice !== undefined && capPrice !== "") {
    $(".addtocart-product-compare_at_price").text(capPrice);
  } else {
    $(".addtocart-product-compare_at_price").text("");
  }
  $(document).on("click", ".quantity__button-plus ", function () {
    $(".main-quantity__button-plus").trigger("click");
  });
  $(document).on("click", ".quantity__button-minus", function () {
    $(".main-quantity__button-minus").trigger("click");
  });
  
$(window).scroll(function () {
    if($('.rc-template__radio').length > 0) {
      $(".sticky-subscriptions-value").addClass("subscriptions-active");
      }
      var scroll = $(window).scrollTop();
      if (mobileView) {
        if (scroll >= 1340) {
          $("#ProductSubmitButton-Sticky").addClass("activesticky");
        } else {
          $("#ProductSubmitButton-Sticky").removeClass("activesticky");
        }
      }
      if (desktopView) {
        if (scroll >= 700) {
          $("#ProductSubmitButton-Sticky").addClass("activesticky");
        } else {
          $("#ProductSubmitButton-Sticky").removeClass("activesticky");
        }
      }
    });

  $(".custom-varinat-input-name").click(function () {
    var capPrice = $(".custom-varinat-input-name:checked").attr("compare_prc");
    var regularPrice = $(".custom-varinat-input-name:checked").attr(
      "cuspricecount"
    );
    if (regularPrice) {
      $(".addtocart-product-price").text(regularPrice);
    }
    if (capPrice !== undefined && capPrice !== "") {
      $(".addtocart-product-compare_at_price").text(capPrice);
    } else {
      $(".addtocart-product-compare_at_price").text("");
    }
  });
});
